/**
 * @file 履歴書エリア追加
 */
'use strict';
import Template from '../../Template/Template';
import Validate from './Validate';
import ApplyClass from '../../Utils/ApplyClass';

/**
 * @classname AddResumeArea
 * @classdesc 履歴書エリア追加
 */
export default class AddResumeArea {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('AddResumeArea.constructor');
		this._$e = $e;
		this._controller = controller;
		this._$resumeArea = $e.closest('.block--resume-area');
		this._resumeType = $e.attr('data-resume-type');
		this._$resumeArea.find('.form-group').each((idx) => {
			this._controller._resumeAreaNo = idx + 1;
		});
		$e.on('click', () => this.onClick());
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof AddResumeArea
	 * @return {undefined}
	 */
	onClick() {
		console.log('AddResumeArea.onClick');
		this._controller._resumeAreaNo++;

		if(this._resumeType === 'occupation'){
			this._$resumeArea.append(Template.addPrArea_occupation(this._controller._resumeAreaNo));
		}else if(this._resumeType === 'qualification'){
			console.log('資格の数：：' + $('#qualification').find('.form-group').length)
			if(this._controller._resumeAreaNo <= 3){
				this._$resumeArea.append(Template.addPrArea_qualification(this._controller._resumeAreaNo));
			}
		}

		this.activate();
	};


	/**
	 * 履歴書エリアアクティベート
	 *
	 * @memberof AddResumeArea
	 * @return {undefined}
	 */
	activate() {
		console.log('AddResumeArea.activate');
		const $resumeArea = this._$resumeArea.find(`.form-group[data-no=${this._controller._resumeAreaNo}]`);
		const $addBtn = $resumeArea.find('.btn--add-resume-area');
		const $deleteBtn = $resumeArea.find('.btn--remove-resume-area');
		$addBtn.on('click', () => {
			this.onClick();
		});
		$deleteBtn.on('click', () => {
			this._controller._resumeAreaNo--;
			$deleteBtn.closest('.form-group').remove();
			this.setResumeTextNo();
			this.addBtnView();
		});
		$resumeArea.find('.validate').each((idx, e) => {
			const $e = $(e);
			ApplyClass.apply(Validate, $e, [$e, this._controller]);
		});
		this.setResumeTextNo();
		this.addBtnView();
	};

	/**
	 * PR TEXT番号設定
	 *
	 * @memberof AddResumeArea
	 * @return {undefined}
	 */
	 setResumeTextNo() {
		console.log('AddResumeArea.setResumeTextNo');
		if (this._controller._resumeAreaNo !== 1) {
			if(this._resumeType === 'occupation'){
				this._$resumeArea.find('.form-group').each((idx, e) => {
					const no = idx + 1;
					const $e = $(e);
					let roundNum = '';
					if(no <= 20){
						roundNum  = '&#' + (9312 + idx).toString();
					}else{
						roundNum = no;
					}
					$e.attr('data-no', no);
					$e.find('.heading--form-inner-title').html(`職歴${$('<div/>').html(roundNum).text()}`);
					$e.find('.form-group-content-inner--office_name input').attr('class', `office_name0${no} validate input-text`).attr('id', `office_name0${no}`).attr('name', `office_name0${no}`)
					$e.find('.form-group-content-inner--industry select').attr('class', `industry0${no}_id`).attr('id', `industry0${no}_id validate input-select-select`).attr('name', `industry0${no}_id`)
					$e.find('.form-group-content-inner--employment_type select').attr('class', `employment_type0${no}_id validate input-select-select`).attr('id', `employment_type0${no}_id`).attr('name', `employment_type0${no}_id`)
					$e.find('.form-group-content-inner--occupation input').attr('class', `occupation0${no} validate input-text`).attr('id', `occupation0${no}`).attr('name', `occupation0${no}`)
					$e.find('.form-group-content-inner--period input').attr('class', `period0${no} validate input-text`).attr('id', `period0${no}`).attr('name', `period0${no}`)
				});
			}else if(this._resumeType === 'qualification'){
				this._$resumeArea.find('.form-group').each((idx, e) => {
					const no = idx + 1;
					const $e = $(e);
					let roundNum = '';
					if(no <= 20){
						roundNum  = '&#' + (9312 + idx).toString();
					}else{
						roundNum = no;
					}
	
					console.log('■資格:'+ roundNum);
	
					$e.attr('data-no', no);
					$e.find('.heading--form-inner-title').html(`資格${$('<div/>').html(roundNum).text()}`);
					$e.find('.form-group-content-inner--qualification input').attr('class', `qualification0${no} validate input-text`).attr('id', `qualification0${no}`).attr('name', `qualification0${no}`)
					$e.find('.form-group-content-inner--year_of_qualification input').attr('class', `year_of_qualification0${no} validate input-text`).attr('id', `year_of_qualification0${no}`).attr('name', `year_of_qualification0${no}`)
				});
			}
		}
	};

	/**
	 * 資格の上限に達したので、追加ボタンを非表示
	 *
	 * @memberof AddResumeArea
	 * @return {undefined}
	 */
	 addBtnView() {
		console.log('AddResumeArea.addBtnView');
		if(this._controller._resumeAreaNo >= 3){
			this._$resumeArea.find('.btn--add-resume-area').css('display', 'none')
		}else {
			this._$resumeArea.find('.btn--add-resume-area').css('display', 'flex')
		}
	}
}